import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  FormControl,
  Tabs,
  Tab,
  Autocomplete,
} from "@mui/material";

import TabPanel from "../../component/TabPanel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import NoteList from "./list.note";
import AuditList from "./list.audit";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  getAssetById,
  updateAsset,
  deleteAsset,
  getCategoryList,
} from "../../api/asset";
import { getEmployeesList } from "../../api/employee";
import { handleAxiosError } from "../../config/action-config";
import { Controller, useForm } from "react-hook-form";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { showAlert } from "../../actions/alert";
import AssignAsset from "./assign";

const deleteApis = {
  ASSET: deleteAsset,
};

const emptyAssetData = {
  asset_id: "",
  assigned_emp_id: "",
  category_id: "",
  description: "",
  purchasedate: "",
  warrantyrenewalcost: "",
  location: "",
  warrantyexpirationdate: "",
  serialnumber: "",
  unitcost: "",
};

export default function ViewAsset() {
  const {
    control,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [assetData, setAssetData] = useState(emptyAssetData);
  const [employeesList, setEmployeesList] = useState([]);

  const [categoryList, setCategoryList] = useState([]);
  const [assignedTo, setassignedTo] = useState("");

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [operatingSystemValue, setOperatingSystemValue] = useState("");
  const [ramValue, setRamValue] = useState("");
  const [storageValue, setStorageValue] = useState("");

  const onAssetDataUpdate = () => {
    updateAsset(assetData.id, assetData, user.token)
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
        navigate("/asset");
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  console.log("assetData", assetData);

  const loadMasterData = () => {
    getAssetById(params.id, user.token)
      .then((res) => {
        setAssetData(res.data.assetdetails[0]);
        setSelectedCategory(res.data.assetdetails[0].category_id);
        setRamValue(res.data.assetdetails[0].ram);
        setStorageValue(res.data.assetdetails[0].storage);
        setOperatingSystemValue(res.data.assetdetails[0].operatingsystem);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);

  const changeUpdateData = (e) => {
    setAssetData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const onSelectInputUpdateData = (fieldName, value) => {
    switch (fieldName) {
      case "operatingsystem": {
        setAssetData((prev) => ({ ...prev, [fieldName]: value }));
        break;
      }
      case "ram": {
        setAssetData((prev) => ({ ...prev, [fieldName]: value }));
        break;
      }
      case "storage": {
        setAssetData((prev) => ({ ...prev, [fieldName]: value }));
        break;
      }
      case "purchasedate": {
        setAssetData((prev) => ({ ...prev, [fieldName]: value }));
        break;
      }
      case "warrantyexpirationdate": {
        setAssetData((prev) => ({ ...prev, [fieldName]: value }));
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    employeeList();
    categoryAssetList();
  }, []);

  const employeeList = async () => {
    const token = user.token;
    return await getEmployeesList({ name: "" }, token)
      .then((res) => {
        setEmployeesList(res.data.data);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const categoryAssetList = async () => {
    const token = user.token;
    return await getCategoryList({ name: "" }, token)
      .then((res) => {
        setCategoryList(res.data.categories);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "ASSET") {
          navigate("/asset");
        }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };
  const operatingSystemOptions = [
    { label: "Windows" },
    { label: "MacOS" },
    { label: "Linux" },
  ];
  const ramOptions = [
    { label: "2 GB" },
    { label: "4 GB" },
    { label: "6 GB" },
    { label: "8 GB" },
    { label: "16 GB" },
    { label: "32 GB" },
  ];
  const storageOptions = [
    { label: "500 GB" },
    { label: "1 TB" },
    { label: "2 TB" },
  ];
  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Asset Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({ table: "ASSET", row: assetData.id });
              }}
              className="blue-button"
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="asset_id"
              onChange={changeUpdateData}
              value={assetData.asset_id}
              label="Asset Id"
              type="number"
              className="name-textfeild"
              disabled={editDisabled}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="item_name"
              onChange={changeUpdateData}
              value={assetData.item_name}
              label="Asset Name"
              type="text"
              className="name-textfeild"
              disabled={editDisabled}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="category_id"
                id="demo-simple-select"
                value={assetData.category_id}
                onChange={(e) => {
                  changeUpdateData(e);
                  handleCategoryChange(e);
                }}
                // onChange={changeUpdateData}
                label="Category"
                disabled
              >
                <MenuItem value="">Select</MenuItem>
                {categoryList.map((e, i) => (
                  <MenuItem key={i} value={e.id}>
                    {e.category}
                  </MenuItem>
                ))}
                <MenuItem value="None">None</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="description"
              onChange={changeUpdateData}
              value={assetData.description}
              type="text"
              label="Description"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Purchased Date"
                value={assetData.purchasedate}
                disabled={editDisabled}
                onChange={(newValue) => {
                  onSelectInputUpdateData("purchasedate", newValue);
                }}
                renderInput={(params) => (
                  <TextField name="purchasedate" {...params} fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="manufacturer"
              onChange={changeUpdateData}
              value={assetData.manufacturer}
              type="text"
              label="Manufacturer"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="model"
              fullWidth
              label="Model"
              disabled={editDisabled}
              type="text"
              onChange={changeUpdateData}
              value={assetData.model}
            />
          </Grid>
          {selectedCategory === 1 && (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="macaddress"
                fullWidth
                disabled={editDisabled}
                label="MAC Address"
                onChange={changeUpdateData}
                value={assetData.macaddress}
              />
            </Grid>
          )}
          {selectedCategory === 4 && (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="imei"
                fullWidth
                label="IMEI"
                onChange={changeUpdateData}
                value={assetData.imei}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                name="cpu"
                fullWidth
                label="CPU"
                disabled={editDisabled}
                onChange={changeUpdateData}
                value={assetData.cpu}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                value={
                  operatingSystemOptions.find(
                    (option) => option.label === operatingSystemValue
                  ) || operatingSystemValue
                }
                inputValue={operatingSystemValue}
                onInputChange={(event, newInputValue) => {
                  setOperatingSystemValue(newInputValue);
                  onSelectInputUpdateData("operatingsystem", newInputValue);
                }}
                options={operatingSystemOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    disabled={editDisabled}
                    name="operatingsystem"
                    fullWidth
                    label="Operating System"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="location"
              onChange={changeUpdateData}
              value={assetData.location}
              label="Location"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Warranty Expiration Date"
                value={assetData.warrantyexpirationdate}
                disabled={editDisabled}
                onChange={(newValue) => {
                  onSelectInputUpdateData("warrantyexpirationdate", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    name="warrantyexpirationdate"
                    {...params}
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          {(selectedCategory === 1 ||
            selectedCategory === 4 ||
            selectedCategory === 5) && (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                name="serialnumber"
                onChange={changeUpdateData}
                value={assetData.serialnumber}
                label="Serial Number"
                // type="number"
                disabled={editDisabled}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                value={
                  ramOptions.find((option) => option.label === ramValue) ||
                  ramValue
                }
                inputValue={ramValue}
                onInputChange={(event, newInputValue) => {
                  setRamValue(newInputValue);
                  onSelectInputUpdateData("ram", newInputValue);
                }}
                options={ramOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    disabled={editDisabled}
                    {...params}
                    name="ram"
                    fullWidth
                    label="RAM"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                value={
                  storageOptions.find(
                    (option) => option.label === storageValue
                  ) || storageValue
                }
                inputValue={storageValue}
                onInputChange={(event, newInputValue) => {
                  setStorageValue(newInputValue);
                  onSelectInputUpdateData("storage", newInputValue);
                }}
                options={storageOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    disabled={editDisabled}
                    name="storage"
                    fullWidth
                    label="Storage"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="status"
              onChange={changeUpdateData}
              value={assetData.status}
              label="Status"
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              name="unitcost"
              onChange={changeUpdateData}
              value={assetData.unitcost}
              label="Unit Cost($)"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            {editDisabled ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/asset");
                  }}
                  className="cancel-button"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={onAssetDataUpdate}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>
      <br />

      {/*Notes and Audit tab*/}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Notes"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          {/* <Tab
            label="Audit"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          /> */}
          <Tab
            label="Assigned Details"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <NoteList></NoteList>
        </Paper>
      </TabPanel>
      {/* <TabPanel value={tabIndex} index={1}>
        <Paper>
          <AuditList></AuditList>
        </Paper>
      </TabPanel> */}
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <AssignAsset status={assetData.status}></AssignAsset>
        </Paper>
      </TabPanel>
      {/*Notes and Audit tab*/}

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button onClick={onDelete} autoFocus className="blue-button">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableAssetData(data) {
  return {
    asset_id: data.asset_id,
    assigned_emp_id: data.assigned_emp_id,
    category_id: data.category_id,
    description: data.description,
    purchasedate: data.purchasedate,
    warrantyrenewalcost: data.warrantyrenewalcost,
    location: data.location,
    warrantyexpirationdate: data.warrantyexpirationdate,
    serialnumber: data.serialnumber,
    unitcost: data.unitcost,
  };
}
